import { footerLinks } from '@/mocks/home';

export default function Footer() {
  const handleFooterNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-16 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading text-background-50">拷贝漫画</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              免费韩漫、日漫、国漫在线阅读平台。海量高清漫画资源，每日更新，随时随地享受漫画阅读乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">漫画分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => handleFooterNav(e, link.href)}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">帮助支持</h4>
            <ul className="space-y-2.5">
              {footerLinks.help.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => handleFooterNav(e, link.href)}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">关于</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => handleFooterNav(e, link.href)}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50">
          <div className="mb-6">
            <h4 className="text-sm font-semibold text-background-300 mb-3">合作伙伴</h4>
            <p className="text-sm text-background-500">更多合作伙伴即将入驻，敬请期待</p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2020-2026 拷贝漫画 All Rights Reserved. 本站所有漫画内容均来自网络，仅供学习交流使用。
            </p>
            <div className="flex items-center gap-4 text-background-500">
              <span className="cursor-pointer hover:text-primary-400 transition-colors">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="cursor-pointer hover:text-primary-400 transition-colors">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="cursor-pointer hover:text-primary-400 transition-colors">
                <i className="ri-bilibili-line text-lg"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}